import type { FormLocale } from '@jlg-website/shared';
import { formatScheduleSummary } from '../shared/date-time';
import { SuccessPanel } from '../shared/success-panel';
import type { CompletionAction } from '../shared/type';
import type { CallbackSlot } from './type';

type SuccessStepProps = {
  date: string;
  slot: CallbackSlot;
  timeZone: string;
  phone: string;
  locale: FormLocale;
  completionAction?: CompletionAction;
};

/** Confirmation of the slot the visitor picked in the calendar. */
export function SuccessStep({
  date,
  slot,
  timeZone,
  phone,
  locale,
  completionAction,
}: SuccessStepProps) {
  return (
    <SuccessPanel
      summary={formatScheduleSummary(locale, date, slot.label, timeZone)}
      phone={phone}
      locale={locale}
      completionAction={completionAction}
    />
  );
}
